import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { watch } from 'vue';
import { useStore } from 'vuex';
import { latestMessage, type WebSocketMessageWithFields, type WebSocketMessageEmpty } from '@/plugins/ws';

import {RootState} from "@/store";

type ActionErrorWithId = {
  idActionError: number;
};

// Типы для WebSocket сообщений компонента actionErrors
type ActionErrorsListMessage = WebSocketMessageWithFields<'language-action-error-list', {
  actionErrors: unknown[];
}>;
type ActionErrorCreateMessage = WebSocketMessageWithFields<'language-action-error-create' | 'language-action-error-create-success', ActionErrorWithId & {
  idAction: number;
  name: string;
}>;
type ActionErrorDeleteMessage = WebSocketMessageWithFields<'language-action-error-delete' | 'language-action-error-delete-success', ActionErrorWithId>;
type ActionErrorTranslationsMessage = WebSocketMessageWithFields<'language-action-error-translations', {
  actionError: unknown;
}>;

// Объединенный тип для всех сообщений
type ActionErrorsWebSocketMessage = 
  | ActionErrorsListMessage 
  | ActionErrorCreateMessage 
  | ActionErrorDeleteMessage 
  | ActionErrorTranslationsMessage;

// WebSocket message handler

export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'dataActionErrors',
},
  __name: 'actionErrors',
  setup(__props) {

const store = useStore<RootState>();



// Базовый тип для сообщений с ID ошибки действия
const handleWebSocketMessage = (data: ActionErrorsWebSocketMessage): void => {
  if (!data?.signal) return;

  switch (data.signal) {
    case 'language-action-error-list':
      store.dispatch('actionErrors/wsSetActionErrors', { actionErrors: data.actionErrors });
      break;

    case 'language-action-error-create':
    case 'language-action-error-create-success':
      store.dispatch('actionErrors/wsActionErrorCreate', {
        idActionError: data.idActionError,
        idAction: data.idAction,
        name: data.name,
      });
      break;

    case 'language-action-error-delete':
    case 'language-action-error-delete-success':
      store.dispatch('actionErrors/wsActionErrorDelete', { idActionError: data.idActionError });
      break;

    case 'language-action-error-translations':
      store.dispatch('actionError/wsSetActionError', data.actionError);
      break;
  }
};

watch(latestMessage, handleWebSocketMessage);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div"))
}
}

})